import React from 'react';

import { ReactComponent as LikeIcon } from '@assets/icons/costing/like.svg';
import { ReactComponent as DislikeIcon } from '@assets/icons/costing/unlike.svg';
import { ReactComponent as LikedIcon } from '@assets/icons/costing/liked.svg';
import { ReactComponent as UnlikedIcon } from '@assets/icons/costing/unliked.svg';

import CustomDropdown from '@/components/CustomDropdown';
import CommonImage from '@/components/CommonImage';

import CostingSidebar from './CostingSidebar';
const CostingTable = () => {
	return (
		<div className="bg-white">
			<div className="costing-content-header border-bottom border-top pt-3 pb-3">
				<div className="product-content d-flex align-items-start justify-content-between gap-2">
					<div className="d-flex align-items-start gap-2">
						<div className="product-images d-flex align-items-center gap-2 mb-0">
							<CommonImage
								src="/images/3.jpg"
								alt="product"
								width={64}
								height={64}
								className="object-fit-cover"
							/>
							<CommonImage
								src="/images/3.jpg"
								alt="product"
								width={64}
								height={64}
								className="object-fit-cover"
							/>
						</div>
						<div className="product-details pl-2">
							<p className="semibold-14 gray_dark_01">Hawaii Breeze Boys Graphic Tee</p>
							<p className="regular-12 gray_dark_02">Product Description</p>
							<ul className="common-list-component pt-1">
								<li className="regular-12 gray_dark_02">ID: GT25-A4993</li>
								<li className="regular-12 gray_dark_02">
									<span className="regular-12 gray_dark_02">26 Oct 2023</span>
								</li>
							</ul>
						</div>
					</div>
					<div className="brand-and-history d-flex align-items-end gap-2">
						<div className="form-group mb-0">
							<label htmlFor="collection">Brand</label>
							<CustomDropdown
								title="Project type*"
								onItemClick={() => {}}
								selectedItem={''}
								items={[]}
							/>
						</div>
						<button className="button gray-outline size36 d-flex align-items-center justify-content-center">
							<CommonImage src="/icons/load.svg" alt="history" width={20} height={20} />
							<span className="ml-1 regular-14 gray_dark_01">History</span>
						</button>
					</div>
				</div>
			</div>
			<div className="costing-table-container relative">
				<div className="costing-table-and-summary d-flex flex-wrap gap-3">
					<div className="all-costing-table mb-4">
						<div className="single-table costing-table-content p-3 border">
							<div className="d-flex justify-content-between mb-2">
								<p>Fabric</p>
								<p>$0.55</p>
							</div>
							<div className="costing-table">
								<table className="table no-hover">
									<thead>
										<tr>
											<th>Metric</th>
											<th>
												<div className="d-flex align-items-center justify-content-between">
													<p>Fabric 1</p>
													<CommonImage
														src="/icons/chip-close.svg"
														alt="edit"
														width={20}
														height={20}
														className="cursor-pointer"
													/>
												</div>
											</th>
											<th>
												<div className="d-flex align-items-center justify-content-between">
													<p>Fabric 1</p>
													<CommonImage
														src="/icons/chip-close.svg"
														alt="edit"
														width={20}
														height={20}
														className="cursor-pointer"
													/>
												</div>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Fabrication</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Yarn Price ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Elastane (%)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Elastane Cost ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Peaching Cost ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Knitting Cost ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Dyeing Cost ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Finishing ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Heat Setting ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Special Finish ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">AOP Cost ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Consumption (Kg)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Process Loss (%)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
									</tbody>
								</table>

								<div className="add-more-button w-100">
									<button className="button gray-outline size32 w-100">
										<CommonImage
											src="/icons/plus-20.svg"
											alt="add"
											width={20}
											height={20}
										/>
										<span className="ml-1 regular-14 gray_dark_01">Add Fabric</span>
									</button>
								</div>
							</div>
						</div>
						<div className="single-table costing-table-content p-3 border mt-3">
							<div className="d-flex justify-content-between mb-2">
								<p>Fabric</p>
								<p>$0.55</p>
							</div>
							<div className="costing-table">
								<table className="table no-hover">
									<thead>
										<tr>
											<th>Metric</th>
											<th>
												<div className="d-flex align-items-center justify-content-between">
													<p>Fabric 1</p>
													<CommonImage
														src="/icons/chip-close.svg"
														alt="edit"
														width={20}
														height={20}
														className="cursor-pointer"
													/>
												</div>
											</th>
											<th>
												<div className="d-flex align-items-center justify-content-between">
													<p>Fabric 2</p>
													<CommonImage
														src="/icons/chip-close.svg"
														alt="edit"
														width={20}
														height={20}
														className="cursor-pointer"
													/>
												</div>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Type</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Number of Colors</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Coverage (%)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Area Size</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
										<tr>
											<td>
												<p className="regular-12 gray_dark_02">Cost ($)</p>
											</td>
											<td>
												<input type="text" />
											</td>
											<td>
												<input type="text" />
											</td>
										</tr>
									</tbody>
								</table>

								<div className="add-more-button w-100">
									<button className="button gray-outline size32 w-100">
										<CommonImage
											src="/icons/plus-20.svg"
											alt="add"
											width={20}
											height={20}
										/>
										<span className="ml-1 regular-14 gray_dark_01">Add Fabric</span>
									</button>
								</div>
							</div>
						</div>
						<div className="single-table trims-content p-3 border mt-3">
							<div className="d-flex justify-content-between mb-2">
								<p>Trims</p>
								<p>$0.55</p>
							</div>
							<div className="row">
								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Sewing Thread</p>
									<input type="text" defaultValue="0.14" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Main Label</p>
									<input type="text" defaultValue="0.08" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Care Label</p>
									<input type="text" defaultValue="0.12" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Tape-Design/Lace</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Button</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Shank Button</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Snap Button</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Metal Hook & Ring</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Stopper/Pullar</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Nipple Up Rivet</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Buckle</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Cord</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Draw Cord</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">
										Cord/Wire with Metal Stopper
									</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Elastics</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Fusing</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Others</p>
									<input type="text" defaultValue="0" />
								</div>
							</div>
						</div>
						<div className="single-table trims-content p-3 border mt-3">
							<div className="d-flex justify-content-between mb-2">
								<p>Packaging</p>
								<p>$0.62</p>
							</div>
							<div className="row">
								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">
										Carton, Average Quality ($)
									</p>
									<input type="text" defaultValue="0.2" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Polybag, 1 Pcs/Body ($)</p>
									<input type="text" defaultValue="0.1" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">
										Gum Tape, Tag Gun, Silica Gel, Others ($)
									</p>
									<input type="text" defaultValue="0.05" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Mock Leather Badge ($)</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Hangtag with String ($)</p>
									<input type="text" defaultValue="0.15" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">
										Poly and Carton Sticker ($)
									</p>
									<input type="text" defaultValue="0.02" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">
										Additional Tags/Price Tag ($)
									</p>
									<input type="text" defaultValue="0.08" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Sticker ($)</p>
									<input type="text" defaultValue="0.02" />
								</div>
							</div>
						</div>
						<div className="single-table trims-content p-3 border mt-3">
							<div className="d-flex justify-content-between mb-2">
								<p>CM</p>
								<p>$0</p>
							</div>
							<div className="row">
								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">CPM ($)</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">SMV</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Efficiency (%)</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Overhead ($)</p>
									<input type="text" defaultValue="0" />
								</div>
							</div>
						</div>
						<div className="single-table trims-content p-3 border mt-3">
							<div className="d-flex justify-content-between mb-2">
								<p>Commercial</p>
								<p>$0</p>
							</div>
							<div className="row">
								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Bank Charges ($)</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Inspection ($)</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Insurance ($)</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Courier Cost ($)</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Testing ($)</p>
									<input type="text" defaultValue="0" />
								</div>

								<div className="col-md-6 col-sm-12 mb-2">
									<p className="regular-12 gray_dark_02 pb-1">Other Charges ($)</p>
									<input type="text" defaultValue="0" />
								</div>
							</div>
						</div>
					</div>
					<div className="costing-summary-container">
						<div className="costing-summary border p-3">
							<div className="d-flex justify-content-between">
								<p className="semibold-14 gray_dark_01">Costing Summary</p>
								<CommonImage
									src="/icons/download-gray-dark-02.svg"
									alt="edit"
									width={20}
									height={20}
								/>
							</div>
							<div className="summary-content mt-3">
								<div className="d-flex justify-content-between pb-2">
									<p className="regular-14 weight-500 gray_dark_02">Fabric Consumption</p>
									<p className="regular-14 gray_dark_01">$0.00 kg</p>
								</div>
								<div className="d-flex justify-content-between pb-2">
									<p className="regular-14 weight-500 gray_dark_02">Fabric Cost</p>
									<p className="regular-14 gray_dark_01">$0.00</p>
								</div>
								<div className="d-flex justify-content-between pb-2">
									<p className="regular-14 weight-500 gray_dark_02">Print/Embroidery</p>
									<p className="regular-14 gray_dark_01">$0.00</p>
								</div>
								<div className="d-flex justify-content-between pb-2">
									<p className="regular-14 weight-500 gray_dark_02">Trims cost</p>
									<p className="regular-14 gray_dark_01">$0.00</p>
								</div>
								<div className="d-flex justify-content-between pb-2">
									<p className="regular-14 weight-500 gray_dark_02">CM cost</p>
									<p className="regular-14 gray_dark_01">$0.00</p>
								</div>
								<div className="d-flex justify-content-between pb-2">
									<p className="regular-14 weight-500 gray_dark_02">Wash cost</p>
									<p className="regular-14 gray_dark_01">$0.00</p>
								</div>
								<div className="d-flex justify-content-between pb-2">
									<p className="regular-14 weight-500 gray_dark_02">Packaging</p>
									<p className="regular-14 gray_dark_01">$0.00</p>
								</div>
								<div className="d-flex justify-content-between pb-2">
									<p className="regular-14 weight-500 gray_dark_02">Commercial</p>
									<p className="regular-14 gray_dark_01">$0.00</p>
								</div>
							</div>
							<div className="content-bottom border-top pt-3 d-flex justify-content-between">
								<p className="regular-12 gray_dark_02">Did you like this cost?</p>
								<div className="d-flex align-items-center gap-2">
									<LikeIcon width={14} height={14} />
									<DislikeIcon width={14} height={14} />
									<LikedIcon width={14} height={14} />
									<UnlikedIcon width={14} height={14} />
								</div>
							</div>
						</div>
						<div className="costing-summary-bottom border mt-3 p-3">
							<div className="d-flex justify-content-between pb-4">
								<p className="semibold-14 gray_dark_01">Total Cost</p>
								<p className="semibold-14 gray_dark_01">$0.00</p>
							</div>
							<button className="button size32 w-100">
								<span className="regular-14 weight-500">Re-Cost</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<CostingSidebar />
		</div>
	);
};

export default CostingTable;
